import React, { useEffect, useRef } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { eventuallyInsertReevooScript } from "../utility/reevoo";

const ReevooBadge = ({ productId }) => {
  const containerRef = useRef();

  const {
    config: { reevoo },
  } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        reevoo: isReevooActiveFieldSet {
          isReevooActive
        }
      }
    }
  `);

  useEffect(() => {
    const container = containerRef.current;
    if (container && productId && !!reevoo?.isReevooActive?.length) {
      eventuallyInsertReevooScript();
    }
  }, [productId, reevoo]);

  return (
    <div ref={containerRef}>
      <div className="feefo-product-stars-widget" data-product-sku={productId}></div>
    </div>
  );
};

export default React.memo(ReevooBadge);
